
<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">物资详情</div>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
          <el-form-item label="物资装备名称" prop="name" style="display:inline-block;">
            <el-input v-model="ruleForm.name" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="物资装备编号" prop="materialNo" style="display:inline-block;">
            <el-input v-model="ruleForm.materialNo" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="物资装备类型" prop="materialType" style="display:inline-block;">
            <el-select
              v-model="ruleForm.materialType"
              style="width:40rem;"
              placeholder="请选择物资装备类型"
              v-bind:disabled="IsEdit"
            >
              <el-option
                v-for="item in options"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物资装备类型子类" prop="materialSubType" style="display:inline-block;">
            <el-select
              v-model="ruleForm.materialSubType"
              style="width:40rem;"
              placeholder="请选择物资装备类型子类"
              v-bind:disabled="IsEdit"
            >
              <el-option
                v-for="item in optionsnext"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="库存数量" prop="stock" style="display:inline-block;">
            <el-input-number
              v-model="ruleForm.stock"
              style="width:40rem;"
              v-bind:disabled="IsAdd"
              :min="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="计量单位" prop="unit" style="display:inline-block;">
            <el-input v-model="ruleForm.unit" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="购入日期" prop="buyDate" style="display:inline-block;">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.buyDate"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="有效日期" prop="validDate" style="display:inline-block;">
            <el-date-picker
              placeholder="选择日期"
              v-model="ruleForm.validDate"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="生产厂家" prop="manufacturer" style="display:inline-block;">
            <el-input
              v-model="ruleForm.manufacturer"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责保管人" prop="responsiblePerson" style="display:inline-block;">
            <el-input v-model="ruleForm.responsiblePerson" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="移动电话" prop="mobileNo" style="display:inline-block;">
            <el-input v-model="ruleForm.mobileNo" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="物资所属企业" prop="belongEnterprise" style="display:inline-block;">
            <el-input v-model="ruleForm.belongEnterprise" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="存放仓库" prop="warehouseId" style="display:inline-block;">
            <el-select
              v-model="ruleForm.warehouseId"
              style="width:40rem;"
              placeholder="请选择存放仓库"
              v-bind:disabled="IsEdit"
              @change="changeWarehouse"
            >
              <el-option
                v-for="item in warehouselist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="存放地址" prop="address" style="display:inline-block;">
            <el-input v-model="ruleForm.address" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <div style="width:116rem; text-align:center;margin:1rem 1rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
        <el-button @click="resetForm()" v-show="IsEdit==false">重置</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import { materialSave, materialUpdate, materialDetail } from '@/api/src/emergency_material'
import { getDictionary } from '@/api/src/emergency_common'
import { warehouseList } from '@/api/src/emergency_warehouse'
export default {
  name: "ZjMaterialinfo",
  controller: "UI",
  action: "Materialinfo",
  props: {
    query: {
      type: String,
      id: String
    }
  },
  data() {
    return {
      loading: true,
      loadingText: "加载中",
      ruleForm: {
        OrgId: "",
        name: "",
        materialNo: "",
        materialType: null,
        materialSubType: null,
        stock: 1,
        unit: "",
        buyDate: "",
        validDate: "",
        manufacturer: "",
        responsiblePerson: "",
        mobileNo: "",
        belongEnterprise: "",
        warehouseId: null,
        address: ""
        /* 
        Latitude: "",
        desc: "" */
      },
      options: [],
      optionsnext: [],
      warehouselist: [],
      rules: {
        name: [
          { required: true, message: "请输入物资装备名称", trigger: "blur" }
        ],
        materialType: [
          { required: true, message: "请选择物资装备类型", trigger: "change" }
        ],
        materialSubType: [
          {
            required: true,
            message: "请选择物资装备类型子类",
            trigger: "change"
          }
        ],
        buyDate: [
          {
            //type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        validDate: [
          { required: true, message: "请选择时间", trigger: "change" }
        ],
        warehouseId: [
          { required: true, message: "请选择存放仓库", trigger: "change" }
        ],
        address:[
          { required: true, message: "请输入存放地址", trigger: "blur" }
        ],
        IsEdit: false,
        IsAdd:true
        //desc: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  created: function() {
    this.basedatabind();
    this.search();
    this.IsEdit = this.query.type == "edit" ? false : true;
    this.IsAdd = this.query.id == "" ? false : true;
    if(!this.IsAdd){
      this.getWarehouseList()
    }
  },
  mounted: function() {},
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        this.ruleForm = {
          name: "",
          materialNo: "",
          materialType: null,
          materialSubType: null,
          stock: 0,
          unit: "",
          buyDate: "",
          validDate: "",
          manufacturer: "",
          responsiblePerson: "",
          mobileNo: "",
          belongEnterprise: "",
          warehouseId: null,
          address: ""
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = "加载中...";
      getDictionary('emergency_material_type')
        .then(res => {
          //物资类型
          this.options = res.data.records;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
      getDictionary('emergency_material_subtype')
        .then(res => {
          //物资子类型
          this.optionsnext = res.data.records;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
 
    },
    getWarehouseList(flag){
      warehouseList({
              size: 2000,
              current: 1
            })
              .then(res => {
                this.warehouselist = res.data.records; // 存放仓库
                if(flag){
                  this.warehouselist.forEach(item => {
                    if (item.id == this.ruleForm.warehouseId) {
                      this.ruleForm.address = item.address;
                    }
                  })
                }
              })
              .catch(e => {
                console.error(e);
                this.loading = false;
              });
    },
    search() {
      let id = this.query.id;
      if (id != null && id != "") {
        this.loading = true;
        this.loadingText = "加载中...";
        materialDetail(id)
          .then(r => {
            r = r.data;
            this.ruleForm = r;
            this.getWarehouseList(true)
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //重置
    resetForm() {
      this.ruleForm = {
          name: "",
          materialNo: "",
          materialType: null,
          materialSubType: null,
          stock: 0,
          unit: "",
          buyDate: "",
          validDate: "",
          manufacturer: "",
          responsiblePerson: "",
          mobileNo: "",
          belongEnterprise: "",
          warehouseId: null,
          address: ""
        };
      this.query.id = null;
    },
    //保存
    submitForm(formName) {
      //this.ruleForm.buyDate=this.stringToDate(this.ruleForm.buyDate);
      //this.ruleForm.validDate=this.stringToDate(this.ruleForm.validDate);
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
    },

    save() {
      this.ruleForm.stock = parseInt(this.ruleForm.stock);
      if (this.user.Departments != null && this.user.Departments.length > 0) {
        var dept = this.user.Departments[0];
        this.ruleForm.OrgId = dept.OrgId; //this.user.OrgId;
      }

      if (this.ruleForm.buyDate > this.ruleForm.validDate) {
        this.errmsg("有效期不能小于购入日期！");
        return;
      }

      if (this.query.id == null || this.query.id == "") {
        this.loading = true;
        this.loadingText = "保存中...";
        materialSave(this.ruleForm)
          .then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.logInfo.ActionName = "应急物资添加";
            this.logInfo.LogMessage = r ? "应急物资添加成功" : "应急物资添加失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急物资详情页面";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.loadingText = "保存中...";
        materialUpdate(this.ruleForm)
          .then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.logInfo.ActionName = "应急物资修改";
            this.logInfo.LogMessage = r ? "应急物资修改成功" : "应急物资修改失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急物资详情页面";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    changeWarehouse(val) {
      const AddressList = this.warehouselist.filter(
        item => item.id == val
      );
      if(AddressList.length>0){
        this.ruleForm.address = AddressList[0].address
      }
    }
  }
};
</script>